import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NouisliderModule } from "ng2-nouislider";
import { TagInputModule } from "ngx-chips";
import { SelectModule } from "ng2-select";
import {
  PacienteComponent,
  DialogOverviewExampleDialog,
  DelegateClients,
  ChangeRep,
  UserChangePasswordComponent,
  ContactHistoryComponent
} from "./paciente.component";

import { PacienteRoutes } from "./paciente.routing";
import { MaterialModule } from "../app.module";
import { HolydaysTableComponent } from "./holydays-table/holydays-table.component";
import { NetTermsModule } from "../net-terms/net-terms.module";
import { ComponentsModule } from "../shared/components/components.module";
import { MatExpansionModule } from '@angular/material/expansion';
import { ManagePermissionsComponent } from './manage-permissions/manage-permissions.component';
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(PacienteRoutes),
    FormsModule,
    ReactiveFormsModule,
    NouisliderModule,
    TagInputModule,
    MaterialModule,
    NetTermsModule,
    ComponentsModule,
    MatExpansionModule,
  ],
  entryComponents: [
    PacienteComponent,
    DialogOverviewExampleDialog,
    DelegateClients,
    ChangeRep,
    UserChangePasswordComponent,
    ContactHistoryComponent
  ],
  declarations: [
    PacienteComponent,
    DialogOverviewExampleDialog,
    DelegateClients,
    ChangeRep,
    HolydaysTableComponent,
    UserChangePasswordComponent,
    ContactHistoryComponent,
    ManagePermissionsComponent
  ],
  exports: [HolydaysTableComponent],
})
export class PacienteModule {}
